import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import NotFoundSvg from 'assets/images/home/no_results_found.svg?react';

export const NoRowsOverlay = () => {
	const { t } = useTranslation(['common']);

	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'center',
				width: 1,
				height: 1,
			}}>
			<NotFoundSvg />
			<Typography sx={{ marginTop: -1.5 }} variant="body1">
				{t('common:resultsNoFound')}
			</Typography>
		</Box>
	);
};
